import { render } from "./RestaurantCard.vue?vue&type=template&id=034f8932"
import script from "./RestaurantCard.vue?vue&type=script&lang=js"
export * from "./RestaurantCard.vue?vue&type=script&lang=js"

import "./RestaurantCard.vue?vue&type=style&index=0&id=034f8932&lang=css"
script.render = render

export default script